<template>
  <div>
    <div class="content-box">
      <div class="element-wrapper" style="background-color: white">
        <div class="element-box">
          <div class="row d-flex justify-content-between">
            <router-link class="btn btn-sm btn-dark" :to="{name: 'wms-categoria-usuario'}">
              <i class="fas fa-angle-double-left sliding-icon">         
              </i> Regresar
            </router-link>
            <div>
              <div class="btn-group dropleft">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-cogs"></i>&nbsp;Acciones
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <button class="dropdown-item" @click="abrirModal(null)">
                    <i class="fas fa-plus"></i>&nbsp;Agregar
                  </button>
                  <button class="dropdown-item" @click="abrirModalClonar()" >
                    <i class="fas fa-edit"></i>&nbsp; Clonar
                  </button>
                </div>
              </div>
            </div>
          </div>
            <div class="row mt-3">        
              <div class="col-lg-12">
                <div class="element-wrapper">            
                  <div class="element-box noBoxes">
                    <div class='row blue_gradient_bg shadow noBoxes shadow_inset'>
                      <div class="col-12 pt-4 px-4">
                        &nbsp;&nbsp;                
                      </div>
                      <div class="position-relative noBoxes">
                        <i class="fas fa-user-edit bgIcons"></i>
                      </div>
                      <div class="col-12 pb-4 pt-2 px-4">
                        <h5 class="font-weight-bold pt-3" style="color: #888; padding-bottom: 0px; margin-bottom: 0px;">
                          Editar
                        </h5>
                        <h2 class="font-weight-bold text-white">
                          Categorías y Sub Categorías                    
                        </h2>                  
                      </div>
                    </div>
                    <!-----------------ENCABEZADO--------------------------->
                    <div class="form-header " style="text-align:center;">
                      <div 
                        class="d-flex justify-content-center titulo-animado"
                        :class = "{
                          'titulo-animado-activo': animarTitulo,
                          'titulo-animado-inactivo': animarSalida
                        }">                  
                        <div class="text-center rounded border border-success pt-2" style="width:300px">
                          <h5>  
                            <i class="fa fa-user fa-lg text-success"></i>
                            {{ titulo }}                                          
                          </h5>                            
                        </div>                  
                      </div>
                      <div class="mt-1 btn-group" role="group" aria-label="Acciones Principales">
                        <button type="button" class="btn btn-success" @click="abrirModalClonar()" style="width:142px"> 
                          <i class="fa fa-clone"></i>
                            Clonar 
                        </button>   
                        <button type="button" class="btn btn-outline-success" @click="abrirModal(null)" style="width:142px">
                          <i class="fa fa-plus"></i>
                            Agregar
                        </button>             
                      </div>                        
                    </div>
                      <!---------------FIN ENCABEZADO---------------------->
                      <!-- <div class="row py-0 px-3" v-if="!existeUsuario">
                        <div class="col-12 col-md-6 mx-auto">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text text-success">
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <v-select
                              label="name"
                              v-model="pickeador"
                              class="form-control px-0 py-0 "
                              :filterable="false"
                              :options="users.results"
                              @search="onSearch"
                              @onChange = "onChangePickeador"
                              :disabled = "false"
                              :clearable ="true"
                              >
                              <template slot="no-options">usuarios...</template>
                              <template slot="option" slot-scope="option">
                                <div class="selected d-center">
                                  {{ option != null ? option.username : '' }}
                                </div>
                              </template>
                              <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                  {{ option !=null ? option.username: '' }}
                                </div>
                              </template>
                            </v-select>                      
                          </div>
                        </div>
                      </div> -->
                    
                      <!--------------------TABLA DE RESULTADOS-------------------->
                      <!---------------------Encabezado tabla---------------------------->
                      <div class="table-responsive mt-5 px-3" >           
                        <table class="table table-hover">
                          <thead>
                            <th>Fecha Inicio</th>
                            <th>Fecha Fin</th>
                            <th>Tienda origen</th>
                            <th>Tienda destino</th>
                            <th>Categoria</th>
                            <th>Sub categoria</th>
                            <th>Tipo tarea</th> 
                            <th>Proveedor</th>                     
                            <!-- <th>Dar de Baja</th> -->
                          </thead>
                          <tbody>
                          <!---------------------Fin Encabezado tabla---------------------------->
                          <!--------------------- DATOS DE TABLA--------------------------->
                            <template v-for="(categoria,key) in dataTabla.results">
                              <!-- <tr data-toggle="modal" data-target ="#AgregarCategoriasModal"> -->
                              <tr @click="abrirModal(categoria)">  
                                <td>{{ moment(categoria.fecha_inicio).format('DD/MM/YYYY') }}</td>
                                <td>{{ moment(categoria.fecha_fin).format('DD/MM/YYYY') }}</td>
                                <td>{{ categoria.tienda_origen_obj.codigo }} -- {{  categoria.tienda_origen_obj.nombre }}</td>
                                <td>{{ categoria.tienda_destino_obj.codigo }} -- {{ categoria.tienda_destino_obj.nombre }} </td>
                                <td class="text-left">{{categoria.categoria ? categoria.categoria.codigo +" -- "+ categoria.categoria.nombre : ' -- '}}</td>
                                <td class="text-left">{{ categoria.sub_categoria ? categoria.sub_categoria.codigo + ' -- '+ categoria.sub_categoria.nombre : ' -- '}}</td>
                                <td>{{ categoria.tarea_tipo }}</td>
                                <td class="small">{{ categoria.proveedor ? categoria.proveedor.id + " -- " +  categoria.proveedor.nombre : " -- " }} </td>                   
                              </tr>
                            </template>
                          <!------------------Fin datos de tabla------------------------->
                          </tbody>
                        </table>
                      <PaginationComponent
                        :currentPage="currentPage"
                        :data="dataTabla"
                        @pagechanged="onPageChange"                                   
                      />
                    </div>              
                  </div>  
                </div>
              </div>
            
          </div>    
        </div>
      </div>
    </div>
    <EditarCategoriaModal v-show="mostrarModal" :pickeador="pickeador" @refresh="refresh" :registroCategoria = "registroCategoria"
      @cerrarModal="cerrarModal"/>
    <ClonarCategoriasComponent v-show="mostrarModalClonar" :pickeador="pickeador" @cerrarModalClonar="cerrarModalClonar"
      @refreshData= "refreshData" :datos_completos="datos_completos"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DynamicService from "../../../../services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import moment from "moment";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import SubCategoriaSelectComponent  from "@/components/commons/SubCategoriaSelectComponent ";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import EditarCategoriaModal from "@/components/wms/utilidades/Asignar_tarea_usuario/EditarCategoriaModal";
import ClonarCategoriasComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/ClonarCategoriasComponent";


  export default {
    components:{
      TiendaSelectComponent,
      CategoriaSelectComponent,
      SubCategoriaSelectComponent,      
      ProveedoresSelectComponent,  
      PaginationComponent,
      EditarCategoriaModal,
      ClonarCategoriasComponent
    },
    data(){
      return{
        currentPage:1,
        current:{
          pickeador:"",
          fecha_inicio:"",
          fecha_fin:"",
          categoria:"",
          sub_categoria:"",
          tarea_tipo:"",
          estatus:false,
          proveedor: "",
        },
        //------------------
        tienda_origen:{
          tienda: "",
        },
        tienda_destino:{
          tienda:""
        },
        categoria:{},
        sub_categoria:{},
        //------------------------
        existeUsuario:false,
        dataTabla:[],
        moment,
        tarea_tipo:[],
        pickeador:[],
        mostrarCategoria:true,
        mostrarSubCategoria:true,
        cantidad_resultados:0,
        /**Animaciones */
        animarTitulo: false,
        animarSalida: false,
        mostrarEncabezado: false,
        titulo: "",
        keyCategorias:0,
        registroCategoria: {},
        mostrarModal:false,
        mostrarModalClonar: false,
        datos_completos: [],
      }
    },
    watch:{
      pickeador(val){            
        if(val==null){          
          this.pickeador = [];          
          this.dataTabla = [];

          this.animarTitulo = false
          this.animarSalida = true

          setTimeout(() => {
            this.animarSalida = false
            this.mostrarEncabezado = false
          }, 500);
          return;
        }    
        if(val && Object.keys(val).length!==0){   
          this.current.pickeador= val.id  
          this.titulo=""
          this.titulo = val.username  
          this.animarSalida = false
          this.animarTitulo = false

          this.$nextTick(()=>{
            setTimeout(()=>{
              this.animarTitulo = true
            }, 10);
          });
          if(!this.existeUsuario){                      
            this.obtenerCategoriasSubcategorias({
              page: 1,
              pickeador_referencia: val.id,
              sin_paginacion:false
            })         
            this.obtenerCategoriasSubcategorias({
              page: 1,
              pickeador_referencia: val.id,
              sin_paginacion:true
            })
          }         
        }         
      }, 
      categoria:{
        handler(val){  
          //cuando hay valor en input categoria  
          if(val && val.categoria!=null && this.current.sub_categoria==""){            
            this.current.categoria = val.categoria.codigo            
          }else if(val && val.categoria!=null && this.current.sub_categoria !== ""){  
            Notifications.alert.error("Acción inválida",
            "Solo puede seleccionar una categoria **o** una subcategoría")          
            this.current.categoria=""
            this.categoria ={}

            //se fuerza a renderizar input para mostrar vacío
            this.mostrarCategoria = false;
            this.$nextTick(()=> {
              this.mostrarCategoria= true
            });
          }  
          
          //cuando no hay valor (se limpio input categoria)        
          if(val && val.categoria == null){                    
            this.current.categoria = "";            
          }                
        },
        deep:true 
      },
      sub_categoria:{
        handler(val){                    
          if(val&&val.subcategoria!= null && this.current.categoria==""){            
            this.current.sub_categoria = val.subcategoria.codigo            
          }else if(val && val.subcategoria !=null && this.current.categoria !== ""){
            Notifications.alert.error("Acción inválida",
            "Solo puede seleccionar una categoria **o** una subcategoría")
            
            //Se limpia current y se limpia input
            this.current.sub_categoria=""
            this.sub_categoria ={}

            //se fuerza a renderizar input para mostrar vacío
            this.mostrarSubCategoria = false;
            this.$nextTick(()=> {
              this.mostrarSubCategoria= true
            });
          }
          
          //cuando no hay valor (se limpio input sub_categoria)        
          if(val && val.subcategoria== null){  
            this.current.sub_categoria = "";
          }  
        }, 
        deep:true
      }
    },
    computed:{
      ...mapGetters("accounts", ["users"])
    },
    async created(){     
      this.$store.dispatch("accounts/users",{
        page: 1
      })
  
      if(this.$route.params.id){             
        await this.getPickeador_obj(this.$route.params.id)      
        this.existeUsuario = true;
      }else{   
        this.pickeador = [];
        this.existeUsuario = false;
      }      
    },
    mounted(){
      let self=this;      
      if(this.pickeador.length !==0){  
        self.obtenerCategoriasSubcategorias({
          page: 1,
          pickeador_referencia: this.pickeador.id,
          sin_paginacion:false
        });       
      }    
      self.obtenerTipoTareas();
    },
    methods:{
      /************************************************* */
      onSearch(search,loading){
        loading(true);
        this.search(loading,search,this)
      },
      search: _.debounce((loading,search,vm)=>{
        if(search =="" || search == null){
          loading(false);
          return;
        }
        let that=this;
        vm.$store.dispatch("accounts/users",{
          activo:true,
          page: 1,
          "filter[search]": search,
        });
        loading(false);
      }, 350),
      /********************************************* */

      onChangePickeador(value){
        this.current.pickeador=value.id;      
      },
      obtenerCategoriasSubcategorias(params){
        let self=this;        
        DynamicService.getActionList(
          "wms",
          "asignar-tarea-usuario", 
          "get_tareas_usuario", 
          params
        ).then((response)=>{   
          if(params.sin_paginacion){     
            self.datos_completos = response.data
          }else{
            self.cantidad_resultados = response.data.count  
            if(response.data.count==0){
              Notifications.alert.error("No hay tareas activas",
              "Este usuario no tiene tareas activas o no es parte del equipo de picking")
              self.pickeador = [] 
              this.animarTitulo = false
              this.animarSalida = true
              setTimeout(() => {
                this.animarSalida = false
                this.mostrarEncabezado = false
              }, 500);
              return;         
            } else{
              self.dataTabla = response.data                
            } 
          }                              
        
        })        
      },
      obtenerTipoTareas(){
        let self= this;
        let params = {
          quitar_paginacion: true,
        }
        DynamicService.fetch("wms","tarea-tipo",params).then((response)=>{          
          self.tarea_tipo =response.data;
        })
      },   
      darDeBaja(categoria){
        let self = this       
        Notifications.alert.confirm(
        "Dar de baja",
        "¿Desea dar de baja la categoria/subcategoría?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "asignar-tarea-usuario",
            categoria.id,
            "dar_de_baja"
          )
            .then((response) => {            
              Notifications.alert.success(
                "Dar de Baja",
                "Realizado Exitosamente"
              );          
              self.refresh();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Error al dar de baja",
                error
              );
            });
          }
        );
      },   
      refresh(){
        let self=this;             
        self.cantidad_resultados -= 1       
        let modulo = (self.cantidad_resultados % 10)       
        if(modulo == 0 )
        {                 
          this.currentPage = self.cantidad_resultados/10
        }      
        self.obtenerCategoriasSubcategorias({
          page: this.currentPage,
          pickeador_referencia: self.current.pickeador,
          sin_paginacion:false
        });
      },
      refreshData(id){
        let self = this;       
        self.getPickeador_obj(id)       
        self.pickeador = []
        self.obtenerCategoriasSubcategorias({
          page: 1,
          pickeador_referencia: id,
          sin_paginacion:false,
        })
      },
      onPageChange(page){               
        this.currentPage = page;
        this.obtenerCategoriasSubcategorias({
          page: this.currentPage,
          pickeador_referencia: this.current.pickeador,
          sin_paginacion:false,
        });
      },
      async getPickeador_obj(id){
        let self = this;     
        await DynamicService.getById("accounts","usuarios",id)
        .then((response)=>{ 
          self.pickeador = response.data        
        })
      },
      abrirModal(registro){
        let self = this;    
        self.registroCategoria = registro      
        self.mostrarModal=true;     
        $("#modalEditarCategoria").modal("show")
        
      },
      cerrarModal(){
        let self = this;       
        self.mostrarModal=false;      
        $("#modalEditarCategoria").modal("hide");
        
      },
      abrirModalClonar(){
        let self=this;
        self.mostrarModalClonar=true;     
        $("#modalClonarCategoria").modal("show")
      },
      cerrarModalClonar(){
        let self=this;
        self.mostrarModalClonar=false;
        $("#modalClonarCategoria").modal("hide")
      }
    }  
  }

</script>

<style>
.sin_borde{
  border: none !important;
  padding: 0 !important;
  margin: 0 !important; 
  box-shadow: none !important;
}
</style>